import { render, staticRenderFns } from "./Imprints.vue?vue&type=template&id=d0e99f22&scoped=true"
import script from "./Imprints.vue?vue&type=script&lang=js"
export * from "./Imprints.vue?vue&type=script&lang=js"
import style0 from "./Imprints.vue?vue&type=style&index=0&id=d0e99f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e99f22",
  null
  
)

export default component.exports